export default "__VITE_ASSET__9a84195b__"